import PromoCode from './promo-code'

export function initPromoCodes () {
  const promoCodeInstances = []
  const promoCodeElements = document.querySelectorAll('[id^="promo-"]')

  promoCodeElements.forEach((element) => {
    const instance = new PromoCode(element)
    promoCodeInstances.push(instance)
  })
}

initPromoCodes()
